import i18n, { mapLocaleToMoment } from '../i18n';
import RestX from '~/RestX';
import moment from 'moment';

import ifExists from '~/utils/ifExists';

class I18nService {
    static changeLocale(localeItem) {
        moment.locale(mapLocaleToMoment(localeItem.locale));
        i18n.locale = localeItem.locale;
        RestX.getInterfaces().localeModule.setLocaleItem(localeItem);
    }

    static getLocale() {
        return (
            ifExists(
                RestX.getInterfaces().localeModule.getLocaleItem(),
                it => it.locale
            ) || i18n.locale
        );
    }
}

export default I18nService;
